import { render, staticRenderFns } from "./XhBusinessStatus.vue?vue&type=template&id=6673ebb2&scoped=true&"
import script from "./XhBusinessStatus.vue?vue&type=script&lang=js&"
export * from "./XhBusinessStatus.vue?vue&type=script&lang=js&"
import style0 from "./XhBusinessStatus.vue?vue&type=style&index=0&id=6673ebb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6673ebb2",
  null
  
)

component.options.__file = "XhBusinessStatus.vue"
export default component.exports